import * as React from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Toolbar,
  Edit,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { useState, useEffect } from "react";

// import { data as orderData } from "./data";
// import { NumericTextBoxComponent } from "@syncfusion/ej2-react-inputs";
// import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
// import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
// import { DataUtil } from "@syncfusion/ej2-data";
// import { Browser, extend, isNullOrUndefined } from "@syncfusion/ej2-base";
import "./grid.css";
// import { toast, Toast } from "react-hot-toast";
import { getGvgData } from "../../api/PupilApi";

function AdminGvg() {
  const [ setLoading] = useState(false);
  const [data, setData] = useState([]);
  const toolbarOptions = ["Search"];
  const editSettings = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
  };
  // const validationRules = { required: true };
  // const orderidRules = { required: true, number: true };
  const pageSettings = { pageCount: 5 };

  useEffect(() => {
    loadData();
  }, []);
  const loadData = () => {
    setLoading(true);
    getGvgData()
      .then((res) => {
        //toast.success(res.data.message);
        //alert("data"+JSON.stringify(res.data));

        setData(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.message) {
          //toast.error(error.message);
          //toast.error("error");
        } else {
          //toast.error("Sorry! Something went wrong. Please try again!");
          //toast.error("error");
        }
        setLoading(false);
        console.log(error);
      });
    setLoading(false);
  };
  return (
    <div className="control-pane flex-1 m-5">
      <div className="control-section">
        <GridComponent
          dataSource={data}
          toolbar={toolbarOptions}
          allowPaging={true}
          editSettings={editSettings}
          pageSettings={pageSettings}
        >
          <ColumnsDirective>
          <ColumnDirective
              field="appliedFor"
              headerText="Requested For"
              width="150"
              textAlign="Center"
            ></ColumnDirective>
          <ColumnDirective
              field="mobile"
              headerText="Mobile No"
              width="150"
              textAlign="Center"
            ></ColumnDirective>
            <ColumnDirective
              field="orderListSize"
              headerText="No.Orders"
              width="150"
              textAlign="Center"
            ></ColumnDirective>
            <ColumnDirective
              field="planSize"
              headerText="No.Plans"
              width="150"
              textAlign="Center"
            ></ColumnDirective>
            <ColumnDirective
              field="name"
              headerText="Name"
              width="150"
              textAlign="Center"
              isPrimaryKey={true}
            ></ColumnDirective>
            <ColumnDirective
              field="email"
              headerText="Email"
              width="150"
              textAlign="Center"
            ></ColumnDirective>
          
          </ColumnsDirective>
          <Inject services={[Page, Toolbar, Edit]} />
        </GridComponent>
      </div>
    </div>
  );
}

export default AdminGvg;
